import React from 'react';
import PropTypes from 'prop-types';
import { Col, Input, Label, Row, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { useActionButton } from '../../../hooks/useCalendar/useRecordBlocs/useActionButton';
import { Auth } from '../../../config/configuration/react';
import { DefaultAlertModal } from '../../common/Modal/DefaultAlertModal';
import Translate, { t } from '../../common/Translate';

export const ActionButton = ({ recordId, formId, label = '' }) => {
  const {
    isLoading,
    action,
    buttonTitle,
    error,
    isError,
    ctaNrm,
    formEntity,
    showRefreshCta,
    nextAction,
    isOpen,
    disableBtn,
    onChangeBtn,
    onChangeBrand,
    toggle,
    possibleBrands,
    createRecord,
    isChecked,
    isNrmFile,
    isBEUser,
    setSelectedLanguage,
    errorMessage,
    setErrorMessage,
    addGrayCardDate,
    goToVehicleIdentify,
  } = useActionButton(recordId, formId, label);
  const isCarcheckUser = Auth.isCarcheckUser();
  const isNrmUser = Auth.isNrmUser();
  const languages = [
    { title: 'languagePDFFrench', code: 'FR' },
    { title: 'languagePDFDutch', code: 'NL' },
  ];
  if (formEntity.sendingInspectionInProgress() || formEntity.inspectionReport() === true) return null;

  if (action === null) return null;

  const body = (
    <>
      <>
        {isNrmFile && (
          <div className="d-flex align-items-center mb-4">
            <FontAwesomeIcon icon={faBell} color="red" className="mr-3 fa-lg" />
            <span className="text-danger" style={{ lineHeight: 1.4 }}>
              {' '}
              {t('useOfPhoneWarning')}{' '}
            </span>
          </div>
        )}
        <Row className="mb-2">
          <Col className="checkbox">
            <Input type="checkbox" onChange={onChangeBtn} checked={isChecked} />{' '}
            <span className="text-primary">{t('gdprClientInformedOfDataProcessing')}</span>
          </Col>
        </Row>
      </>
      {isBEUser && (
        <Row>
          <Col>
            <Label className="text-primary text-left mb-2" for="selectLanguage">
              <Translate code="languagePDF" />
            </Label>
            <Input
              className="form-control rounded mb-0"
              type="select"
              onChange={(e) => setSelectedLanguage(e.target.value)}
              placeholder="selectLanguage"
            >
              {languages.map((l) => (
                <option value={l.code}>{t(l.title)}</option>
              ))}
            </Input>
          </Col>
        </Row>
      )}
      {possibleBrands.length > 1 && isNrmFile && (
        <Row>
          <Col className="mt-4">
            <Label className="text-primary text-left mb-3" for="selectFilesBrand">
              <Translate code="selectFilesBrand" />
            </Label>
            <Input
              className="form-control rounded mb-0"
              type="select"
              onChange={onChangeBrand}
              placeholder="selectBrand"
            >
              <option key="select" value={null}>
                {t('select')}
              </option>
              {possibleBrands.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.brandName}
                </option>
              ))}
            </Input>
          </Col>
        </Row>
      )}
    </>
  );
  return (
    !Auth.roleViewerAccess() && (
      <div className="calendar-meeting-folder-action">
        {addGrayCardDate && (
          <div>
            <button type="button" className="btn btn-1" style={{ width: 'auto' }} onClick={goToVehicleIdentify}>
              {isLoading && <Spinner size="sm" className="mr-1" />}
              {t('completeVehicleIdentification')}
            </button>
          </div>
        )}
        {isError && <p className="text-danger">{error}</p>}
        {!addGrayCardDate && (isCarcheckUser || (isNrmUser && nextAction !== 'initialize')) && (
          <div>
            <button
              type="button"
              data-test={`${nextAction}-btn`}
              className={`btn ${(!showRefreshCta && 'btn-1') || 'btn-3'}`}
              onClick={action}
            >
              {isLoading && <Spinner size="sm" className="mr-1" />}
              {buttonTitle}
            </button>
          </div>
        )}
        <div>
          {ctaNrm && (
            <button
              type="button"
              data-testid={`${nextAction}-nrm-record`}
              className="btn btn-1 btn-nrm"
              onClick={ctaNrm?.action}
              onBlur={() => setErrorMessage('')}
            >
              {isLoading && <Spinner size="sm" />}
              {ctaNrm?.title}
            </button>
          )}
          {errorMessage && <p className="text-danger"> {t(errorMessage)} </p>}
        </div>
        <DefaultAlertModal
          isOpen={isOpen}
          toggle={toggle}
          withHeader={false}
          body={body}
          cancelBtn="cancle"
          validateBtn="confirm"
          handleCancel={toggle}
          handleValidate={createRecord}
          disable={disableBtn}
          centered
          size="md"
        />
      </div>
    )
  );
};

ActionButton.propTypes = {
  recordId: PropTypes.number.isRequired,
  formId: PropTypes.number,
  label: PropTypes.string,
};

ActionButton.defaultProps = {
  formId: 0,
  label: '',
};
